<template>
  <div :class="{ [$style.check]: true, [$style.checked]: checked }" @click="$emit('click')">
    <svg width="24" height="17" viewBox="0 0 24 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1 7.22222L8.85714 15L23 1" stroke="#EDEEF0" :stroke-width="checked ? 3 : 2"/>
    </svg>
  </div>
</template>
<script>
export default {
  name: 'Check',
  props: {
    checked: Boolean,
  },
}
</script>
<style lang="scss" module>
.check {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  user-select: none;
  svg path {
    transition: all .3s ease;
  }
}

.checked {
  svg path {
    stroke: $color-blue;
  }
}
</style>
